import {AUTH_TOKEN_KEY, IMPERSONATION_TOKEN_KEY, REFRESH_TOKEN_KEY} from '@shared/constants/auth'
import {setHomeAppCookie, clearHomeAppCookie} from '@shared-utils/auth/homeAppCookie'
import {getImpersonationUserToken} from '@shared-utils/auth/impersonation/helpers'
export function authActions({axios}) {
  return {
    async setToken(token) {
      localStorage.setItem(AUTH_TOKEN_KEY, token)
      await this.setUserIsAuthenticated(!!token)
    },

    setImpersonationToken(token) {
      sessionStorage.setItem(IMPERSONATION_TOKEN_KEY, token)
    },

    getAuthToken() {
      return sessionStorage.getItem(IMPERSONATION_TOKEN_KEY) || localStorage.getItem(AUTH_TOKEN_KEY)
    },

    async handleImpersonationToken(user_id) {
      const {data} = await axios.post('auth/login/impersonate', {user_id})
      return {token: data.token, origin: data.origin}
    },

    async impersonate(impUserId) {
      const {token} = await this.handleImpersonationToken(impUserId)
      this.setImpersonationToken(token)
      await this.loadAuthUserInfo()
      return token
    },

    async loginAndSetToken(payload) {
      let data
      try {
        const response = await axios.post('oauth/token', payload)
        data = response.data
        await this.setToken(data.access_token)
        if (data.refresh_token) {
          localStorage.setItem(REFRESH_TOKEN_KEY, data.refresh_token)
        }
      } catch (e) {
        await this.removeUserToken()
        throw e
      }

      try {
        await this.loadAuthUserInfo()
      } catch (e) {
        console.error('loadAuthUserInfo failed after token exchange; keeping token for retry', e)
      }

      return data
    },

    async refreshAccessToken() {
      const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY)
      if (!refreshToken) {
        throw new Error('No refresh token available')
      }
      const {data} = await axios.post(
        'oauth/token',
        {
          grant_type: 'refresh_token',
          client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
          refresh_token: refreshToken,
        },
        {_skipRefresh: true},
      )
      localStorage.setItem(AUTH_TOKEN_KEY, data.access_token)
      if (data.refresh_token) {
        localStorage.setItem(REFRESH_TOKEN_KEY, data.refresh_token)
      }
      return data.access_token
    },

    async setUserIsAuthenticated(payload) {
      this.isAuthenticated = payload
    },

    async getAuthUserFullInfo() {
      const {data} = await axios.get('user-info', {
        params: {
          with: [
            'company.organization',
            'unit',
            'employee.manager',
            'company.csm',
            'company.csm_2',
            'company.sale_manager',
            'company.media_planner',
            'company.media_planner_2',
          ],
        },
      })

      return data
    },

    async loadAuthUserInfo() {
      try {
        const {data} = await axios.get('user-info', {
          params: {
            with: ['company.organization', 'unit', 'employee.manager'],
          },
        })

        this.user = data
        this.isAuthenticated = true
        if (!getImpersonationUserToken()) {
          setHomeAppCookie(data.policies?.is_point2web_employee)
        }
      } catch (error) {
        console.error('loadAuthUserInfo failed', error)
        throw error
      }
    },
    async updateUserProperty(property, value) {
      this.user[property] = value
    },

    async removeUserToken() {
      localStorage.removeItem(AUTH_TOKEN_KEY)
      localStorage.removeItem(REFRESH_TOKEN_KEY)
      clearHomeAppCookie()
      await this.setUserIsAuthenticated(false)
    },

    async logout() {
      try {
        await axios.post('auth/logout')
      } finally {
        await this.removeUserToken()
      }
    },

    async sendForgotPasswordRequest(payload) {
      const {data} = await axios.post('auth/forgot-password', payload)
      return data
    },

    async sendResetPasswordRequest(payload) {
      const {data} = await axios.post('auth/reset-password', payload)
      return data
    },

    async endImpersonation(user_id) {
      const {data} = await axios.post('auth/login/end-impersonation', {user_id})
      return data
    },
  }
}
